import { queryOptions, useQuery } from "@tanstack/react-query";

import type { Conversation } from "~/conversations/types/conversation";
import type { GetConversationsParams } from "~/conversations/api/get-conversations";
import { getConversations } from "~/conversations/api/get-conversations";
import { mapConversationResponseToModel } from "~/conversations/utils/map-conversation-response-to-model";

function getConversationsQueryOptions(params: GetConversationsParams) {
  return queryOptions({
    queryKey: ["conversations", ...Object.entries(params)],
    async queryFn() {
      const conversations = await getConversations(params);
      return conversations.map(mapConversationResponseToModel);
    },
  });
}

function useGetConversations<TSelect = Conversation[]>(
  params: GetConversationsParams,
  select?: (data: Conversation[]) => TSelect,
) {
  return useQuery({
    ...getConversationsQueryOptions(params),
    select,
  });
}

export { getConversationsQueryOptions, useGetConversations };
